
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { ElMessage, ElNotification } from "element-plus";
import {
  createCruiseContext,
  createNodeContext,
} from "@/script/apps/recon/config/ReconConfig";
import { Cruise, Node } from "@/script/apps/recon/entity/ReconEntity";
import { Camera } from "@/script/apps/device/entity/DeviceEntity";
import { createCameraContext } from "@/script/apps/device/config/DeviceConfig";

@Options({})
export default class CruiseDetail extends BaseDetail {
  nodes?: Node[] = [];
  cameras?: Camera[] = [];

  public initData(): ServiceContext {
    return createCruiseContext();
  }

  public newEntity() {
    const entity: Cruise = { node: { name: "" }, camera: { name: "" } };
    return entity;
  }

  protected initOptions() {
    super.initOptions();

    createNodeContext().service.loadFullList((data: Node[]) => {
      this.nodes = data;
    });
    createCameraContext().service.loadFullList((data: Camera[]) => {
      this.cameras = data;
    });
  }
}
